import {memo} from 'react'
import {Mercure} from './Mercure'

const topics = ['/']

export const MercurePublic = memo(() => {
  return <Mercure topics={topics}/>
})
